import React from "react";
import { Modal, Table, Spin } from "antd";
import moment from "moment";
import Bridge from "../../constants/Bridge";
import Strings from "../../constants/Strings";

class ViewARESScore extends React.Component {
  // state list
  constructor(props) {
    super(props);
    this.state = {
      status: false,
      modalLoader: false,
      modalStatus: false,
      list: [],
      selectedOption: "",
      graphdata: [],
      paginationNum: 10,
      loading: false,
      options: [
        {
          name: "Speech",
          value: "speech",
        },
        {
          name: "Salvation",
          value: "salvation",
        },
        {
          name: "Swallowing",
          value: "swallowing",
        },
        {
          name: "Hand Writing",
          value: "handwriting",
        },
        {
          name: "Cutting Food A",
          value: "cutting_food_a",
        },
        {
          name: "Cutting Food B",
          value: "cutting_food_b",
        },
        {
          name: "Dressing And Hygiene",
          value: "dressing_and_hygiene",
        },
        {
          name: "Walking",
          value: "walking",
        },
        {
          name: "Climbing Stairs",
          value: "climbing_stairs",
        },
        {
          name: "Dyspnea",
          value: "dyspnea",
        },
        {
          name: "Orthopnea",
          value: "orthopnea",
        },
        {
          name: "Respiratory Insufficiency",
          value: "respiratory_insufficiency",
        },
      ],
    };
  }
  // on load component function
  componentDidMount() {}
  // on change table pagination
  handleTableChange = (pagination, filters, sorter) => {
    this.setState({ paginationNum: pagination.pageSize });
  };
  // show modal
  showDetailsModal = () => {
    let item = this.props.item;
    this.setState({ modalLoader: true }, () =>
      this.getNotesForParticipant(item)
    );
  };
  // get als frs for participant
  getNotesForParticipant = (item) => {
    let eals_id = item.eals_id;
    let url = `?eals_id=${eals_id}&participants_accounts_id=${item.participants_accounts_id}`;
    Bridge.participants
      .get_ares_score_list(url)
      .then((response) => {
        if (response.status == "1") {
          this.setState({
            list: response.data,
            modalLoader: false,
            modalStatus: true,
          });
        } else {
          this.setState({
            modalLoader: false,
            modalStatus: true,
            list: [],
          });
        }
      })
      .catch(function (error) {});
  };
  // sloe details modal
  hideDetailsModal = () => {
    this.setState({ modalStatus: false });
  };
  render() {
    const dataSource =
      this.state.list &&
      this.state.list.map((item, index) => {
        return {
          key: index,
          date: item.date,
          at_rest_in_chair: item,
          lying_in_flat_bed: item,
          while_eating: item,
          combining_hair: item,
          getting_dressed: item,
          stading_up_from_chair: item,
          walking_100_feet_at_own_pace: item,
          walking_up_1_flight: item,
          how_much_fatigue_limit: item,
          how_often_do_wake_up_headache: item,
          how_often_fall_asleep_while_engaging_social: item,
          how_often_awaken_at_night: item,
        };
      });
    const Columns = [
      {
        title: "Date",
        dataIndex: "date",
        key: "date",
        width: 80,
      },
      {
        title: "At Rest In a Chair",
        dataIndex: "at_rest_in_chair",
        key: "at_rest_in_chair",
        width: 120,
        render: (item) => {
          return (
            <div>
              <div>{item.at_rest_in_chair ? item.at_rest_in_chair : "---"}</div>
            </div>
          );
        },
      },
      {
        title: "Lying In Flat Bed",
        dataIndex: "lying_in_flat_bed",
        key: "lying_in_flat_bed",
        width: 120,
        render: (item) => {
          return (
            <div>
              <div>
                {item.lying_in_flat_bed ? item.lying_in_flat_bed : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "While Eating",
        dataIndex: "while_eating",
        key: "while_eating",
        width: 120,
        render: (item) => {
          return (
            <div>
              <div>{item.while_eating ? item.while_eating : "---"}</div>
            </div>
          );
        },
      },
      {
        title: "Combining Hair or Shaving",
        dataIndex: "combining_hair",
        key: "combining_hair",
        width: 130,
        render: (item) => {
          return (
            <div>
              <div>{item.combining_hair ? item.combining_hair : "---"}</div>
            </div>
          );
        },
      },
      {
        title: "Getting Dressed",
        dataIndex: "getting_dressed",
        key: "getting_dressed",
        width: 140,
        render: (item) => {
          return (
            <div>
              <div>{item.getting_dressed ? item.getting_dressed : "---"}</div>
            </div>
          );
        },
      },
      {
        title: "Stading Up From a Chair or Bed",
        dataIndex: "stading_up_from_chair",
        key: "stading_up_from_chair",
        width: 180,
        render: (item) => {
          return (
            <div>
              <div>
                {item.stading_up_from_chair
                  ? item.stading_up_from_chair
                  : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "Walking 100 Feet At Own Pace",
        dataIndex: "walking_100_feet_at_own_pace",
        key: "walking_100_feet_at_own_pace",
        width: 140,
        render: (item) => {
          return (
            <div>
              <div>
                {item.walking_100_feet_at_own_pace
                  ? item.walking_100_feet_at_own_pace
                  : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "Walking Up 1 Flight of Stairs",
        dataIndex: "walking_up_1_flight",
        key: "walking_up_1_flight",
        width: 180,
        render: (item) => {
          return (
            <div>
              <div>
                {item.walking_up_1_flight ? item.walking_up_1_flight : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "How Much Does Fatigue Limit Your Activity?",
        dataIndex: "how_much_fatigue_limit",
        key: "how_much_fatigue_limit",
        width: 180,
        render: (item) => {
          return (
            <div>
              <div>
                {item.how_much_fatigue_limit
                  ? item.how_much_fatigue_limit
                  : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "How Often Do You Wake Up With a Headache?",
        dataIndex: "how_often_do_wake_up_headache",
        key: "how_often_do_wake_up_headache",
        width: 180,
        render: (item) => {
          return (
            <div>
              <div>
                {item.how_often_do_wake_up_headache
                  ? item.how_often_do_wake_up_headache
                  : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title:
          "How often do you fall asleep while engaging in usual social activities?",
        dataIndex: "how_often_fall_asleep_while_engaging_social",
        key: "how_often_fall_asleep_while_engaging_social",
        width: 180,
        render: (item) => {
          return (
            <div>
              <div>
                {item.how_often_fall_asleep_while_engaging_social
                  ? item.how_often_fall_asleep_while_engaging_social
                  : "---"}
              </div>
            </div>
          );
        },
      },
      {
        title: "How often do you awaken at night?",
        dataIndex: "how_often_awaken_at_night",
        key: "how_often_awaken_at_night",
        width: 180,
        render: (item) => {
          return (
            <div>
              <div>
                {item.how_often_awaken_at_night
                  ? item.how_often_awaken_at_night
                  : "---"}
              </div>
            </div>
          );
        },
      },
    ];
    return (
      <>
        <a onClick={() => this.showDetailsModal()}>
          <i
            className="fas fa-eye"
            style={{
              color: "#000",
              fontSize: 18,
              position: "relative",
              top: 2,
            }}
          ></i>
          <span style={{ fontSize: 14, marginLeft: 10 }}>View ARES Score</span>
        </a>{" "}
        {/* Start als frs modal  */}
        <Modal
          title={"View ARES Score"}
          visible={this.state.modalStatus}
          onOk={this.hideDetailsModal}
          onCancel={this.hideDetailsModal}
          width={750}
          footer={false}
        >
          <div>
            <Spin spinning={this.state.modalLoader}>
              <div className="row participant-div ares-score-table">
                <Table
                  dataSource={dataSource}
                  loading={this.state.loading}
                  pagination={{ pageSize: this.state.paginationNum }}
                  columns={Columns}
                  scroll={{ x: 2200 }}
                  onChange={this.handleTableChange}
                />
              </div>
            </Spin>
          </div>
        </Modal>
        {/* End als frs modal  */}
      </>
    );
  }
}
export default ViewARESScore;
